import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { Alert, Container } from '@mui/material';
import { useAuth } from '../contexts/AuthContext';

const AdminRoute = () => {
  const { isAdmin } = useAuth();

  if (!isAdmin) {
    return (
      <Container maxWidth="sm" sx={{ mt: 4 }}>
        <Alert severity="error">
          You do not have permission to access this page. Admin access required.
        </Alert>
      </Container>
    );
  }

  return <Outlet />;
};

export default AdminRoute;